import { httpService } from 'common/api';
import LoadImage from 'blueimp-load-image';

class PaperworkEntryService {
    basePath = "paperwork-entry";

    find({ pageNumber, pageSize, embeds, sort, status }) {
        return httpService.get(`${this.basePath}?pageNumber=${pageNumber}&pageSize=${pageSize}&embeds=${embeds}&sort=${sort}&status=${status}`)
    }

    get({ id, embeds }) {
        return httpService.get(`${this.basePath}/${id}?embeds=${embeds}`)
    }

    getHistory({ paperworkEntryId, embeds }) {
        return httpService.get(`${this.basePath}/history/${paperworkEntryId}?embeds=${embeds}`)
    }
  
    getPaperworkImage({ id, embeds }) {
        return httpService.get(`${this.basePath}/imageInfo/${id}?embeds=${embeds}`)
    }

    updatePaperworkImage(entry) {
        return httpService.post(`${this.basePath}/imageUpdate`, entry)
    }

    updatePaperworkEntryStatus(id, data) {
        return httpService.put(`${this.basePath}/paperworkStatus/${id}`, data)
    }  

    createPaperworkEntryPrintLog(ids) {
        return httpService.post(`${this.basePath}/PrintLog`, {list: ids})
    }
    
    getPdfDocument(ids) {
        var entry = {list: ids}
        return httpService.downloadPDF(`${this.basePath}/GetPdfDocument`, entry);
    }

    getPaperworkStatuses(includeFilterValues) {
        return httpService.get(`lookup/paperwork-status?includeFilterValues=${includeFilterValues}`)
    }

    async getImageUrl(id, thumb = true) {
        const prefix = thumb ? 'thumb-' : '';
        var blob = await httpService.download(`${this.basePath}/image/${prefix}${id}`);
        return new Promise((resolve, reject) => {
            LoadImage(
                blob,
                function (canvas) {
                    if (canvas.toBlob) {
                        canvas.toBlob(function (canvasBlob) {
                            orientation(canvasBlob, function (base64img) {
                                var img = new Image;
                
                                img.onload = function () {
                                    resolve({
                                        data: base64img,
                                        options: {      
                                            size: {
                                                width: img.width,
                                                height: img.height,
                                            }
                                        }
                                    });
                                };
                
                                img.src = base64img;
                            });
                        })
                    } else {
                        reject();
                    }
                },
                {
                    orientation: true
                }
            );
        });





        return URL.createObjectURL(blob);
    }
}

// Exif orientation value to css transform mapping
// Does not include flipped orientations
var rotation = {
    1: 'rotate(0deg)',
    3: 'rotate(180deg)',
    6: 'rotate(90deg)',
    8: 'rotate(270deg)'
};
function _arrayBufferToBase64(buffer) {
    var binary = ''
    var bytes = new Uint8Array(buffer)
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
    }
    return window.btoa(binary);
}

function orientation(file, callback) {
    var fileReader = new FileReader();
    fileReader.onloadend = function () {
        var base64img = "data:" + file.type + ";base64," + _arrayBufferToBase64(fileReader.result);
        // var scanner = new DataView(fileReader.result);
        // var idx = 0;
        // var value = 1; // Non-rotated is the default
        // if (fileReader.result.length < 2 || scanner.getUint16(idx) != 0xFFD8) {
        //     // Not a JPEG
        //     if (callback) {
        //         callback(base64img, value);
        //     }
        //     return;
        // }
        // idx += 2;
        // var maxBytes = scanner.byteLength;
        // while (idx < maxBytes - 2) {
        //     var uint16 = scanner.getUint16(idx);
        //     idx += 2;
        //     switch (uint16) {
        //         case 0xFFE1: // Start of EXIF
        //             var exifLength = scanner.getUint16(idx);
        //             maxBytes = exifLength - idx;
        //             idx += 2;
        //             break;
        //         case 0x0112: // Orientation tag
        //             // Read the value, its 6 bytes further out
        //             // See page 102 at the following URL
        //             // http://www.kodak.com/global/plugins/acrobat/en/service/digCam/exifStandard2.pdf
        //             value = scanner.getUint16(idx + 6, false);
        //             maxBytes = 0; // Stop scanning
        //             break;
        //     }
        // }
        if (callback) {
            callback(base64img);
        }
    }
    fileReader.readAsArrayBuffer(file);
};


const paperworkEntryService = new PaperworkEntryService();
export { paperworkEntryService }


// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/paperworkEntryService.js